import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThunder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconThunder"><Path d="M20 10.5H13.5L16 1.75L4 13.5H10.5L8 22.25L20 10.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconThunder;
